module.exports = __webpack_public_path__ + "assets/character.e19372988cc9bb2c25b6b8b3f1aaada6.svg";